import React from "react";
import { useStyles } from "./TrailingPeriodScreenStyles.css";

const CountdownBar = ({ dimensions }) => {
    const classes = useStyles({ dimensions });

    return (
        <div className={classes.countdownContainer}>
            <div className={classes.countdownBar} />
        </div>
    );
};

export default CountdownBar;
